export const STORE_USER = 'STORE_USER';
export const LOADING_AUTHENTICATION = 'LOADING_AUTHENTICATION';

export const STORE_LAST_FILTERS_APPLIED = 'STORE_LAST_FILTERS_APPLIED';
export const STORE_FILTER_OPTIONS = 'STORE_FILTER_OPTIONS';

export const STORE_USER_LANGUAGE = 'STORE_USER_LANGUAGE';
export const STORE_TRANSLATIONS = 'STORE_TRANSLATIONS';
